function TotalContribution({
  totalContributionTitle,
  contributionValue,
  deathBenefitValue,
  tpdDetails,
  totalMonthlyPayable,
  totalMonthlyPayableValue,
  discount,
  notSingle,
  fscPercentage,
  fscFeeValue,
  adminPercentage,
  adminFeeValue,
  className = "",
}) {
  const totals = [
    {
      id: 0,
      title: totalContributionTitle,
      value: contributionValue,
    },
    {
      id: 1,
      title: "Death Benefit",
      value: deathBenefitValue,
    },
    {
      id: 2,
      title: "Total & Permanent Disability",
      value: tpdDetails,
    },
    {
      id: 3,
      title: "FSC Fee",
      value: fscFeeValue,
      percentage: fscPercentage,
    },
    {
      id: 4,
      title: "Admin Fee",
      value: adminFeeValue,
      percentage: adminPercentage,
    },
    {
      id: 5,
      title: totalMonthlyPayable,
      value: totalMonthlyPayableValue,
    },
  ];

  return (
    <main className={`tw-font-haas tw-bg-white tw-border tw-border-gray tw-w-auto tw-h-auto tw-rounded-xl tw-p-8 ${className}`}>
      <span className="tw-text-xl tw-text-black/50">Total Contribution</span>
      <div className="tw-pt-4">
        {totals.map((t) => {
          const isHeader = t.id === 0;
          const isFooter = t.id === 5;
          const showPercentage =
            (t.id === 3 || t.id === 4) &&
            t.percentage !== undefined &&
            t.percentage !== null;

          return (
            <section
              key={t.id}
              className="tw-grid tw-grid-cols-6 tw-gap-4 tw-border tw-border-gray tw-bg-transparent tw-capitalize"
            >
              <div
                className={`
                  tw-col-span-4 tw-w-full tw-h-auto lg:tw-h-auto tw-p-4 tw-border-r tw-border-gray tw-flex tw-gap-2 tw-flex-col lg:tw-flex-row tw-items-start lg:tw-items-center
                  ${isHeader ? "tw-bg-black/5" : ""}
                  ${!isHeader && !isFooter ? "tw-text-black/50" : ""}
                  ${isFooter ? "tw-font-bold" : ""}
                `}
              >
                <div className="tw-flex tw-w-full tw-items-center tw-gap-2">
                  <div
                    className={`tw-pr-12 tw-text-sm tw-text-black ${
                      isFooter ? "tw-font-bold" : "tw-font-normal"
                    }`}
                  >
                    {t.title}
                  </div>
                  <div className="tw-ml-auto tw-flex tw-items-center tw-justify-end tw-gap-2">
                    {notSingle && isFooter && (
                      <div className="tw-w-fit tw-px-3 tw-text-xs tw-font-normal tw-text-white tw-bg-[#BEC663] tw-whitespace-nowrap tw-h-auto tw-rounded-3xl tw-p-2">
                        {"- " + discount + " %"}
                      </div>
                    )}
                    {showPercentage && (
                      <div className="tw-w-fit tw-px-3 tw-text-xs tw-font-normal tw-text-white tw-bg-[#BEC663] tw-whitespace-nowrap tw-h-auto tw-rounded-3xl tw-p-2">
                        {t.percentage + " %"}
                      </div>
                    )}
                  </div>
                </div>
              </div>

              <div className="tw-col-span-2 tw-h-auto tw-p-4 tw-justify-self-end">
                <span
                  className={`tw-text-sm tw-text-black ${
                    isFooter ? "tw-font-bold" : "tw-font-normal"
                  }`}
                >
                  {typeof t.value === "number"
                    ? t.value.toLocaleString()
                    : t.value}
                </span>
              </div>
            </section>
          );
        })}
      </div>
    </main>
  );
}
export default TotalContribution;
